export default class Dispatcher {
    constructor (app) {
        this.app = app;
    }

    dispatch (requestedInstances) {
        throw new Error('The dispatch must be implemented by Dispatcher subclasses');
    }
}



// WEBPACK FOOTER //
// ./src/app/dispatcher.js